export default {
	props: {
		roomBasePrice: Number,
		currency: String,
		precision: {type: Number,default: 0},
		extraServices: {type:Object, default:()=>({})},
	},
	data(){
		return {
			/*extraServices: {}*/
		}
	},
	watch:{

	},
	computed: {
		roomBasePriceFormatted(){
			return formatAmount(this.roomBasePrice, this.currency, this.precision, true, this.$i18n.locale);
		},
		itemTotalPrice(){
			let sum = this.roomBasePrice;
			for(let i in this.extraServices){
				sum += this.extraServices[i].qty*this.extraServices[i].price;
			}
			return sum;
		},
		itemTotalPriceFormatted(){
			return formatAmount(this.itemTotalPrice, this.currency, this.precision,true, this.$i18n.locale);
		}
	},
	methods: {
		changeExtraService(es_id, price, qty){
			let tmp = JSON.parse(JSON.stringify(this.extraServices));
			if(qty>0){
				tmp[es_id] = {es_id:es_id, price:price, qty:qty};
			}
			else {
				delete tmp[es_id];
			}
			this.$emit('change', tmp);
		},
	},
	template: `
<slot v-bind="{extraServices,changeExtraService,roomBasePriceFormatted,itemTotalPriceFormatted}"></slot>
`,
}
